export interface ImportResult {
  id: string;
  guideId: string;
  guideCode?: string;
  accountSlug?: string;
  status: "pending" | "processing" | "completed" | "failed";
  rowCount: number;
  importedCount: number;
  errorCount: number;
  errors: Array<{ row: number; message: string }>;
  importKind?: "csv" | "pdf_ai";
  cacheHit?: boolean;
}

export function importProgressMessage(job: ImportResult): string {
  if (job.status === "pending") return "Waiting to begin.";
  if (job.status === "processing") {
    if (job.rowCount < 1)
      return "Scanning the source file and detecting agenda items.";
    return `${String(job.importedCount)} of ${String(job.rowCount)} items prepared.`;
  }
  if (job.status === "failed") return "The import could not be completed.";
  if (job.errorCount)
    return `${String(job.importedCount)} of ${String(job.rowCount)} items imported. ${String(job.errorCount)} row${job.errorCount === 1 ? " needs" : "s need"} attention.`;
  return `${String(job.importedCount)} item${job.importedCount === 1 ? "" : "s"} imported.`;
}
